export const messagesConnections = {
    pt: {
        message:{
            action: "Ação",
            connected: "Conectados",
            device: "Aparelho",
            identification: "Identificação",
            import: "Importar",
            importMacAddresses: "Importar Endereços MAC",
            mac: "MAC",
            macAddress: "Endereço MAC",
            update: "Atualizar",
            timeLeft: "Tempo restante",
            unknown: "Desconhecidos",
            numberOfConnections: 'Nº de Conexões'
        }
    },
    es: {
        message:{
            action: "Acción",
            connected:"Conectado",
            device:"Dispositivo",
            identification:"Identificación",
            import: "Importar",
            importMacAddresses: "Importar direcciones mac",
            mac:"MAC",
            macAddress: "Dirección MAC",
            update:"Actualizar",
            timeLeft:"Tiempo restante",
            unknown:"Desconocido",
            numberOfConnections: 'Número de Conexiones'
        }
    },
    en: {
        message:{
            action: "Action",
            connected: "Connected",
            device: "Device",
            identification: "Identification",
            import: "Import",
            importMacAddresses: "Import MAC Addresses",
            mac: "MAC",
            macAddress: "MAC Address",
            update: "Update",
            timeLeft: "Time left",
            unknown: "Unknown",
            numberOfConnections: 'No. of Connections'
        }
    }
}
